import React from "react";

export default class TermsOfService extends React.Component {
  render() {
    return (
      <div>
        <h2>
          <strong>CanaWho&trade; Terms of Service</strong>
        </h2>
        <h2>&nbsp;</h2>
        <p>
          Welcome to the CanaWho community. The Terms of Service (these&nbsp;
          <strong>&ldquo;Terms&rdquo;</strong>) govern your access to use
          CanaWho&rsquo;s (a) mobile applications (the &ldquo;Mobile
          Application&rdquo;), websites, portals and software that link or
          reference these Terms of Use, including CanaWho.com, and (b) social
          media pages and channels (collectively, the &ldquo;Websites&rdquo;),
          including any media, features, services, functions, content, and links
          offered within (collectively, the &ldquo;Services&rdquo;).&nbsp;
        </p>
        <p>
          Please read these Terms carefully, the terms outline a legally binding
          contract between CanaWho who owns the Websites or Services that you
          may use or access, and you and those who follow you (if applicable)
          the corporate or other entity that you represent (in these Terms, you
          shall be referred to as &ldquo;you&rdquo; or &ldquo;your&rdquo;). If
          you access or use any of the Websites or Services, you agree to be
          legally bound by these Terms. If you do not agree or do not accept
          these Terms, you may not: use or access any of the Websites or
          Services, create an account or create a user profile. For purposes of
          these Terms, &ldquo;CanaWho&rdquo;, &ldquo;us&rdquo;, &ldquo;we&rdquo;
          or &ldquo;our&rdquo; shall mean, as applicable, CanaWho Inc. and its
          affiliated entities which: (i) are, directly or indirectly,
          majority-owned by CanaWho Inc.; and (ii) own the applicable Website or
          provide the applicable Services that you may be accessing or using.
        </p>
        <p>&nbsp;</p>
        <p>
          The Terms outlined in this document are subject to occasional changes,
          if we make any changes, we will contact you via email communication to
          the last email address you provided to us and/or by posting a notice
          of the changes on the Websites. Any changes made to these Terms will
          take effect earlier upon sending an email notice to you (if
          applicable) or once there is notice of the changes on the Websites.
          You are responsible for providing us with your most current email
          address. If the last email address you provided to us is no longer
          valid, or is unable to deliver the notice to you as described above,
          our attempt to notify you will nonetheless constitute effective notice
          of the changes described in the notice. If your email address is not
          up to date or is not working, the notice of changes to these Terms
          will be posted on the Websites and that provides effective notice of
          the changes described. If you continue to use any of the Websites or
          Services following the notice of such changes, you indicate your
          acknowledgement of such changes and you agree to be bound by the terms
          and conditions of such changes. If you are registering as a business
          or any other entity, you constitue that you have the authority to bind
          the entity to these Terms and any other related or relevant
          agreements. If you do not hold this authority, you will be held liable
          for all actions taken under your user ID individually. You further
          represent that any party invited by you to participate in any of the
          Services or related functions with you also meets all of the
          requirements of this paragraph.
        </p>
        <h1>
          <strong>1. Eligibility.</strong>
        </h1>
        <p>
          CanaWho provides the Websites and Services for and only for those who
          are nineteen(19) years of age or older, and who are able to knowingly
          enter into legally binding contracts under the applicable law. Please
          refer to the Additional Terms applicable for further information.
          Without limitation to the foregoing, CanaWho&rsquo;s Websites and
          Services are not available nor intended for minors or suspended
          members and/or users.
        </p>
        <p>&nbsp;</p>
        <p>
          If you are registering as a business or other organization, you are
          representing that you have the authority to bind the entity to these
          Terms and any other related agreements. If you do not have this
          authority, you will be held liable for all actions taken under your
          user ID individually. You further represent any party you invite to
          participate in any of the Services or related functions with you must
          also meet all of the requirements outlined in this paragraph.
        </p>
        <p>&nbsp;</p>
        <h1>
          <strong>2. Using Our Services.</strong>
        </h1>
        <h2>&nbsp;</h2>
        <h2>
          <strong>2.1 License Grant.</strong>
        </h2>
        <p>
          Subject to your compliance with these Terms and the applicable
          Additional Terms, CanaWho grants you a limited, non-sublicensable,
          non-exclusive, non-transferable, revocable license to access, make
          personal, and use the Websites and Services for non-commercial
          purposes. All rights not clearly granted to you in these Terms or any
          Additional Terms are reserved and retained by CanaWho.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>2.2 Mobile App License.</strong>
        </h2>
        <p>
          Subject to your compliance with the Terms, CanaWho grants you a
          limited non-exclusive, non-sublicensable, non-transferable, revocable
          license to download, install and use the Mobile Application on a
          single mobile device or computer that you have control of and/or own
          and to run the Mobile Application solely for your own personal or
          internal business purposes.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>2.3 Certain Restrictions.</strong>
        </h2>
        <p>
          You understand and agree that you are entirely responsible for
          compliance with all laws, rules and regulations that may apply to your
          use of the Websites or Services. In connection with your access or use
          of any of the Websites or Services, you may not and will not: post,
          upload, share, broadcast or otherwise make available any offensive or
          unwanted content on the platform, including any user content that is
          unlawful, derogatory, or otherwise objectionable; violation or by-pass
          any laws, third-party rights or our systems, policies, or your account
          status; price manipulation of any item or interfere with any other
          user&rsquo;s listings, products, and reviews; distribute, advertise,
          promote, or post spam, unsolicited or bulk electronic communications,
          chain letters, pyramid schemes or any other related content; interfere
          with or disrupt any Website processes, servers or networks supporting
          the Websites and/or CanaWho or impose an unreasonably large load on
          our infrastructure; impair or harm any of our computer or related
          systems or transmit software viruses, worms, or other damaging files;
          use of any robot, spider, scraper, survey, monitor or other automated
          or similar means to access any web page or other asset contained in
          the Websites, Services or Website Content for any purpose; provide
          material support or resources (or to conceal or disguise the nature,
          location, source, or ownership of material support or resources) to
          any organization(s) circumvent any technical measures we use to
          provide Services; or assist any third party with any of the foregoing.
          CanaWho has the right to investigate and prosecute to the fullest
          extent of the law if any of the outlined violations described above
          are violated.
        </p>
        <p>&nbsp;</p>
        <h1>
          <strong>3. Account and User Registration</strong>
        </h1>
        <p>&nbsp;</p>
        <h2>
          <strong>3.1 Creating Your Account.</strong>
        </h2>
        <p>
          For you to access or use some of the Websites or Services, you must
          register and create an individual User Profile for yourself or a
          Business Profile for the Websites or Services (each represent a
          &ldquo;User Profile&rdquo;). By creating a User Profile, you agree
          that:
        </p>
        <p>&nbsp;</p>
        <ol>
          <li>
            <p>
              You will not create a username that: is taken by someone else, may
              imitate another person, may imitate a brand, belongs to another
              person, belongs to another brand, violates intellectual property,
              violates the right of any person or entity, and/or is offensive.
            </p>
          </li>
          <li>
            <p>
              You will provide accurate and complete registration information
              about yourself when proceeding with the registration process and,
              as allowed, to maintain and update the information continuously to
              keep it current and up to date.
            </p>
          </li>
          <li>
            <p>
              You are responsible for keeping your password confidential, and
              also responsible for restricting access to your account so others
              may not access your password protected portion of the Websites or
              Services using your name, username, or password.
            </p>
          </li>
          <li>
            <p>
              You are entirely responsible for all activities under your
              profile, password, and username&nbsp; whether you authorized the
              activity or not.&nbsp;
            </p>
          </li>
          <li>
            <p>
              You will not share any derogatory content or create false posts or
              misleading reviews.
            </p>
          </li>
          <li>
            <p>
              You will not sell, transfer, or assign your account or any other
              account rights to another individual or group of individuals.
            </p>
          </li>
          <li>
            <p>
              You will immediately contact us if you become aware of any
              unauthorized use of your account, password, or username, or any
              other breach of security;
            </p>
          </li>
        </ol>
        <p>&nbsp;</p>
        <p>
          <strong>If</strong>&nbsp;you provide any information, or if we have
          reasonable grounds to suspect that any information that you provide,
          is false, incomplete, offensive, inaccurate, or violates these Terms,
          any Additional Terms, or any applicable law, then we may
        </p>
        <p>
          suspend or remove your account, User Profile and deny access to and
          use of the Websites and Services, at our sole discretion and without
          advance notice or liability.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>You</strong>&nbsp;may be able to set preferences related to
          your user profile, but these changes to your settings may not become
          effective immediately, and the options may change from time to time.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>CanaWho</strong>&nbsp;does not review every User Profile
          created on the Websites or Services to determine if the account was
          created by an appropriate party, but rather implements an age gate in
          order to create a User Profile. Additionally, CanaWho is not
          responsible for any unauthorized User Profiles that appear on the
          Websites or Services. If you believe that a User Profile listed on one
          of the websites is unauthorized, fake, fraudulent or otherwise
          improper or misleading, you may report the User Profile on the mobile
          application and/or send an email to customerservice@canawho.com.
        </p>
        <p>&nbsp;</p>
        <h1>
          <strong>4. Content&nbsp;Responsibility</strong>
        </h1>
        <h2>&nbsp;</h2>
        <h2>
          <strong>4.1 Content Types.</strong>
        </h2>
        <h2>For these Terms of Use</h2>
        <p>&nbsp;</p>
        <p>
          (a) &ldquo;Content&rdquo; means all: text, images, audio, video,
          graphics, experiences, location data, and all other forms of data,
          communication or media.&nbsp;
        </p>
        <p>&nbsp;</p>
        <p>
          (b) &ldquo;Your Content&rdquo; means Content that you submit and or
          transmit, through the Websites or Services, such as experiences,
          ratings, photos, media, social media posts or services, comments and
          information that you publicly display or displayed in your User
          Profile.&nbsp;
        </p>
        <p>&nbsp;</p>
        <p>
          (c) &ldquo;Registered Brand Content&rdquo; means Content that
          Registered Brands submit or transmit to, through, or in connection
          with the Websites or Services, including any electronic data or
          information with respect to their customers.&nbsp;
        </p>
        <p>&nbsp;</p>
        <p>
          (d) &ldquo;CanaWho Content&rdquo; is Content that we create or is
          owned by CanaWho and we make it available through the Websites or
          Services.&nbsp;
        </p>
        <p>&nbsp;</p>
        <p>
          (e) &ldquo;Third Party Content&rdquo; is Content that does not
          originate from CanaWho or users of any of the Websites or Services,
          but is made available in connection with the Websites or Services and
          not otherwise owned by CanaWho.
        </p>
        <p>&nbsp;</p>
        <p>
          (f) &ldquo;Website Content&rdquo; is all of the Content that is made
          available in connection with the Websites or Services. This includes
          Your Content, User Content, Third Party Content and Third Party
          Material (as defined below), and CanaWho Content.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>4.2 Pre-Screen or Store Content.&nbsp;</strong>
        </h2>
        <p>
          You accept that CanaWho is not responsible for&nbsp; pre-screening all
          Content (including, but not limited to, User Content), although
          CanaWho reserves the right in its sole discretion to pre-screen,
          refuse or remove any Content. By entering into the Terms of Use, you
          hereby provide irreversible consent to this monitoring. You accept and
          agree that you have no expectation of privacy concerning the
          transmission of Your Content, including without limitation chat, text,
          or voice communications. If CanaWho pre-screens, refuses or removes
          any Content, you acknowledge that CanaWho will do so for the benefit
          of CanaWho, not yours, and without any liability to CanaWho. CanaWho
          shall have the right to remove any Content that in CanaWho&rsquo;s
          opinion, violates the Terms or is otherwise objectionable and should
          be removed.&nbsp;
        </p>
        <p>&nbsp;</p>
        <p>
          Unless CanaWho agrees in writing, CanaWho has no responsibility to
          store any of Your Content from the Website or Services. CanaWho has no
          responsibility or liability for the deletion or accuracy of any
          Content on the Websites or Services. This includes Your Content, the
          failure to store, transmit or receive transmission of Content, or the
          security, privacy, storage, or transmission of other communications
          originating with or involving use of the Website or Services. Specific
          Services may give you the ability to specify the level at which such
          Services restrict access to Your Content. You are entirely responsible
          for applying the appropriate level of access to Your Content. If you
          do not choose the settings, then the system may default to its most
          permissive setting. You accept that CanaWho holds the right to create
          reasonable limits on CanaWho&rsquo;s use and storage of the Content,
          including Your Content, such as limits on file size, storage space,
          processing capacity, and similar limits described on the Website and
          as otherwise determined by CanaWho&rsquo;s sole discretion.
        </p>
        <h1>
          <br />
          <strong>5. Ownership; Proprietary Rights</strong>
        </h1>
        <h2>&nbsp;</h2>
        <h2>
          <strong>5.1 CanaWho&rsquo;s Ownership.&nbsp;</strong>
        </h2>
        <p>
          CanaWho owns the Content shared on the Websites and Services,
          including but not limited to visual interfaces, interactive
          components, images, as well as, but not limited to, our collection of
          User Content and other Website Content, computer code, software, data,
          collection of user experiences and all other elements and components
          of the Websites; excluding Your Content, User Content and Third Party
          Material. CanaWho also owns the patents, patent applications,
          trademarks, service marks, copyrights, trade names and other
          intellectual and proprietary rights throughout the world (&ldquo;IP
          Rights&rdquo;) associated with the CanaWho Content, the Websites and
          the Services, which are protected by copyright, trade secret, patent
          and trademark laws and all other applicable intellectual property and
          proprietary rights and laws. Except as expressly and unambiguously
          provided herein, we do not grant you expressed or implied rights, and
          all rights in and to the Websites, Services and the CanaWho Content
          are reserved by us.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>
            5.2 Ownership of Your Content; License to Your Content.
          </strong>
        </h2>
        <p>
          CanaWho does not claim ownership of Your Content. However, when you
          share or publish Your Content on or in the Websites or Services, you
          express that you own and/or have a royalty-free, irreversible,
          perpetual, global, non-exclusive right (including any moral rights)
          and license to use, license, modify, reproduce, publish, translate,
          create other works from, distribute, generate revenue or other
          remuneration from, and communicate to the public, perform and display
          Your Content (in whole or in part) worldwide and/or to incorporate it
          in other works in any form, technology or media now known or later
          developed, for the full term of any worldwide intellectual property
          right that may exist in Your Content.
        </p>
        <p>&nbsp;</p>
        <p>
          You grant CanaWho a fully paid, royalty-free, irreversible, global,
          perpetual, non-exclusive and fully sublicensable right (including any
          moral rights) and license to use, license, distribute, modify,
          reproduce, publicly perform and display, Your Content (in whole or in
          part) for the purposes of operating and providing the Website and
          Services to you and other users. Please remember that other users on
          the platform may search for, see, modify and reproduce, use any of
          Your Content that you submit to any &ldquo;public&rdquo; area on the
          Websites or Services. You warrant that the holder of any worldwide
          intellectual property right, including moral rights, in Your Content,
          has completely and effectively waived all such rights and validly and
          irrevocably granted to you the right to grant the license stated
          above. You agree that you, not CanaWho, are entirely responsible for
          all of Your Content that you make available on the Website or Services
          when uploading and sharing.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>5.3 License to Your Data.&nbsp;</strong>
        </h2>
        <p>
          You hereby grant CanaWho the license to and right to use any data,
          information or images that is published or shared to us through any of
          our APIs by you or by any Third-Party on your behalf (&ldquo;Licensed
          Data&rdquo;) for any reason relating to any of CanaWho&rsquo;s
          businesses or to the Websites or Services, including in connection
          with displaying any data or information on the Websites. You
          acknowledge and agree that we shall have the right to readjust,
          improve, alter, obtain and/or convert any of the Licensed Data and
          that we shall exclusively own all derivative works, improvements,
          modifications, analyses and interpretations of the Licensed Data. Any
          of the Licensed Data prepared, improved and readjusted by CanaWho
          shall be owned exclusively by CanaWho.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>5.4 Review/ Feedback Policy.</strong>
        </h2>
        <p>
          An important part of the CanaWho community is how we receive feedback.
          Users have the ability to share experiences and connect with community
          members, and CanaWho wants that process to be inclusive and welcoming.
          As part of the welcoming community, certain behaviors are not welcome
          or acceptable. CanaWho holds the right to remove any content posted or
          submitted on any of its Websites or Services. The only User Content
          that is likely to be removed is content that violates these Terms of
          Service, the rules or the guidelines on the Website or Service
          regarding experiences, comments and any other User Content (the
          &ldquo;Review Policies&rdquo;). The Review Policies of each Website or
          Service may be different. Please consult with the relevant Website or
          Service to learn about its applicable Review Policy.
        </p>
        <p>&nbsp;</p>
        <p>
          You agree, the submission of any ideas, improvements, information,
          and/or proposals to CanaWho through its feedback system
          (&ldquo;Feedback&rdquo;) is at your own discretion and that CanaWho
          has no obligations (including without limitation obligations of
          confidentiality) with respect to such Feedback. You represent and
          warrant that you have all rights necessary to submit the Feedback. You
          hereby grant CanaWho a fully paid, perpetual, worldwide, royalty-free,
          irrevocable, non-exclusive, and fully sublicensable right and license
          to use, reproduce, distribute, adopt, modify, re-format, create
          derivative works of, and or commercially or non-commercially exploit
          in any way, any and all Feedback, and to sublicense the foregoing
          rights, relating to the operation and maintenance of the Website and
          Services.
        </p>
        <p>&nbsp;</p>
        <p>
          CanaWho is not responsible for enforcing these Terms or any of the
          Review Policies on your&nbsp;
        </p>
        <p>
          behalf against another user. CanaWho encourages you to let us know
          when you think another user has violated these Terms or any of the
          Review Policies, we hold the right to investigate and take suitable
          action at our discretion.
        </p>
        <h1>&nbsp;</h1>
        <h1>6.&nbsp;&nbsp;Interactions with Other Users</h1>
        <h2>&nbsp;</h2>
        <h2>
          <strong>6.1 User Responsibility</strong>
          <strong>.</strong>
        </h2>
        <p>
          You are entirely responsible for your connections with other Community
          Members and any other parties you interact with on the platform.
          CanaWho reserves the right, but has no obligation, to mediate in such
          disputes. You agree that CanaWho will not be responsible for any
          liability incurred as the result of such interactions.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>6.2 Content Provided by Other Users.</strong>
        </h2>
        <p>
          The Websites and Services may contain User Content shared by other
          Users. CanaWho is not responsible for and does not control the User
          Content shared on the platform. CanaWho has no obligation to review or
          monitor, and does not approve, endorse or make any representations or
          warranties with respect to User Content. Use all User Content and
          engage with other community members at your own risk.
        </p>
        <h1>&nbsp;</h1>
        <h2>
          <strong>7. Third Party Services</strong>
        </h2>
        <p>&nbsp;</p>
        <h2>
          <strong>7.1 Third Party Materials.</strong>
        </h2>
        <p>
          The Website or Services may show and include Third Party Content
          (including data, information, articles, content, products, services
          and/or materials) or they may contain links to Third Party websites,
          services, and advertisements for Third Party Offers (as defined below)
          (collectively, the &ldquo;Third Party Materials&rdquo;). You accept
          and agree that CanaWho is not responsible for Third Party Materials.
          This includes accuracy, completeness, timeliness, validity, copyright
          compliance, legality, decency, quality or any other aspect thereof.
          CanaWho does not accept and will not have any liability or
          responsibility to you or any other community member for any Third
          Party Materials. Third Party Materials and links are provided only as
          a convenience to you and you access them completely at your own risk.
          When you link to Third Party Materials, the Third Party&rsquo;s Terms
          and Policies apply, including the Third Party&rsquo;s Privacy and Data
          gathering practices. You should investigate if you feel necessary or
          appropriate before you proceed with any transaction with such Third
          Party Material.
        </p>
        <p>&nbsp;</p>
        <p>
          CanaWho&rsquo;s Websites or Services may show, include or make
          available coupons, promotional codes, giveaways, and other offers from
          listed companies or other third parties (collectively, the
          &ldquo;Offers&rdquo;). Offers represent &ldquo;Third Party
          Materials&rdquo; under these Terms. CanaWho shows these Offers on the
          Websites and Services as a form of advertisement for the listing
          company or other Third Party (the &ldquo;Offeror&rdquo;) only. All
          Offers are made directly by the applicable Offeror whether or not such
          terms, conditions or restrictions are expressly included on the
          Website or Services. These Offers may be subject to additional terms,
          conditions, or restrictions set out by the Offeror or under applicable
          law. CanaWho is not responsible, but the Offeror, is solely
          responsible for: (a) redeeming the Offer; (b) compliance of all
          aspects of the Offer with applicable law (including, without
          limitation, the advertisement, redemption, and terms, conditions and
          restrictions related thereto); (c) all the goods and services provided
          to you in connection with the Offer; and (d) all injuries, illnesses,
          damages, claims, liabilities and costs it may cause you to suffer,
          directly or indirectly, in full or in part, whether related to the use
          or redemption of an Offer or not.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>7.2 App Stores.</strong>
        </h2>
        <p>
          You accept and agree that the Mobile Application and the Services
          available are dependent on the Third Party from whom you received the
          Mobile App license (ie. the Apple App Store or Google Play Store). You
          accept the Terms of Service are between you and CanaWho, and the Terms
          are not between you and the App Store (ie. Apple or Google). CanaWho
          is solely responsible for the Website and the Services, not the App
          Store. This includes the Mobile App, content, platform maintenance,
          warranty, support services, and addressing any claims relating to (ie.
          legal compliance or intellectual property infringement). In order to
          use and access the Mobile Application, you must be connected to a
          wireless network, pay the fees associated with the connection, and pay
          all fees (if any) charged by the App Store in connection with the
          Websites or Services. You agree to comply with all applicable
          third-party terms of agreement, your license to use the Mobile App is
          based on your compliance with all applicable third-party terms of
          agreement (e.g., the App Store&rsquo;s terms and policies) when using
          the Website and the Services. You accept&nbsp;
        </p>
        <p>
          that the App Store (and its subsidiaries) will have the right to
          enforce the Terms.
        </p>
        <h1>
          <br />
          8. Copyright Infringement.
        </h1>
        <p>&nbsp;</p>
        <p>
          CanaWho&rsquo;s policy is to terminate the membership privileges of
          any community member who repeatedly violates copyright upon
          notification to CanaWho by the owner of the copyright or the legal
          agent of the copyright owner. Without limiting the previous, if you
          believe any of your work has been copied and posted on the Websites or
          Services in a way that represents copyright infringement, please
          provide the following information to CanaWho:&nbsp;
        </p>
        <p>&nbsp;</p>
        <p>
          (1) a physical or electronic signature of the person that is
          authorized to act on behalf of the owner of the copyright; (2) a
          description of the copyrighted work that you believe has been copied;
          (3) a description of where the infringement is on the Websites or
          Services; (4) your contact information with your address, telephone
          number and e-mail address; (5) a written statement by you that you
          have a good faith belief that the disputed use is not authorized by
          the copyright owner, its agent or the law; and (6) a statement by you,
          made under penalty of perjury, that the information provided in your
          request is accurate and that you are the copyright owner or authorized
          to act on the copyright owner&rsquo;s behalf. The contact information
          for CanaWho to submit a claim of infringement is located below:
        </p>
        <p>&nbsp;</p>
        <p>CanaWho Inc.</p>
        <p>Customer Service</p>
        <p>customerservice@canawho.com</p>
        <p>2238 Dundas ST W</p>
        <p>PO BOX 59047</p>
        <p>Toronto, Ontario</p>
        <p>M6R 3B5</p>
        <h1>
          <br />
          9. Fees and Purchase Terms.
        </h1>
        <h2>&nbsp;</h2>
        <h2>
          <strong>9.1 General Purpose of Terms: Not Sale of Software.</strong>
        </h2>
        <p>
          The objective of the Terms of Service and all fees set forth within
          and paid by you under the Terms shall be considered only for you to
          secure access to the Services. These fees paid are in no way
          considered payment for the license, sale, or use of CanaWho&rsquo;s
          Software, and any use of CanaWho&rsquo;s Software by you in
          furtherance of the Terms will be considered merely in support of the
          purpose of the Terms.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>9.2 Payment.</strong>
        </h2>
        <p>
          You agree to pay all of your fees or charges in accordance with the
          fees, charges and billing terms in effect at the time a fee or charge
          is due and is payable. You must provide CanaWho with a valid method of
          payment, a credit card (MasterCard, Visa, or any other issuer accepted
          by us) or Stripe account (&ldquo;Payment Provider&rdquo;) are
          acceptable. By providing CanaWho with your payment information (ie.
          credit card or Stripe account), you authorize CanaWho to charge you
          immediately for all fees due and payable to CanaWho hereunder and that
          no additional notice or consent is required. You agree to immediately
          notify CanaWho of any changes in your billing address or payment
          information used for payment hereunder. CanaWho reserves the right to
          change at any time its prices and billing methods, either immediately
          upon posting on the Websites or Services or by e-mail delivery to you.
          You may be charged local tax, if applicable.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>9.3 Purchasing Products.</strong>
        </h2>
        <p>
          If you wish to purchase any products or services through the Services
          (&ldquo;Products&rdquo;), you will need to provide additional
          information applicable to your purchase, including payment, contact,
          and any other information. Any of this information will be treated as
          described in our Privacy Policy. All the information that you provide
          to us or to our Third Party Service Provider for payment services must
          be accurate, up to date and complete. YOU REPRESENT AND AUTHORIZE THE
          LEGAL RIGHT TO USE ANY CREDIT CARDS OR OTHER PAYMENT MEANS USED TO
          INITIATE ANY TRANSACTION. You agree to pay all charges incurred by you
          or any users of your account and credit card (or other applicable
          payment mechanism) at the prices in effect when such charges are
          incurred. You are also responsible for paying any applicable taxes
          relating to any of your purchases. We may be required to verify the
          information applicable to a purchase prior to our acceptance of any
          order.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>9.4 Descriptions of Products.</strong>
        </h2>
        <p>
          Product information, photos, descriptions, content, characteristics,
          specifications, lab results and product availability found on the
          Services are subject to change without notice. We do our best to
          accurately showcase the product, package and colours; however, the
          actual representation you see will depend on your viewing platform
          (ie. computer or mobile device), and we cannot guarantee that your
          viewing platform will accurately represent these products. The
          Products found on the Services does not suggest or guarantee that
          these products or services will be available at any time. It is your
          responsibility to check and confirm with the provider (ie. retail
          location or brand), the availability of any product or service you are
          interested in.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>9.6 Disputes.</strong>
        </h2>
        <p>
          After receiving your credit card statement, you must inform us within
          seven (7) days in writing, if you would like to dispute any of our
          charges on that statement or such dispute will be deemed waived.
          Billing disputes should be notified to customerservice@canawho.com
        </p>
        <h1>
          <br />
          10. Indemnification.&nbsp;
        </h1>
        <p>
          You agree to indemnify and hold CanaWho (and its owners, directors,
          managers, partners, employees, and all affiliates) harmless from any
          and all losses, damages, liabilities, claims, actions, judgments,
          awards, penalties, fines, costs and expenses (including reasonable
          attorney(s) fees) arising from or relating to any claim or demand made
          by any Third Party due to or arising out of or otherwise relating to
          (1) your use or misuse of the Websites or Services, (2) Your Content,
          (3) your violation of these Terms or any Additional Terms; or (4) your
          violation of applicable laws or regulations. CanaWho reserves the
          right, at your expense, to assume the exclusive defense and control of
          any matter for which you are required to indemnify us or any other
          indemnitee hereunder and you agree to cooperate with our defense of
          these claims. You agree not to resolve any matter without the prior
          written consent of CanaWho. CanaWho will use reasonable efforts to
          notify you of any such claim, action or proceeding upon becoming aware
          of it.
        </p>
        <p>
          <br />
          11. Disclaimer of Warranties
        </p>
        <h2>&nbsp;</h2>
        <h2>You expressly acknowledge, understand and agree that:</h2>
        <p>&nbsp;</p>
        <ol>
          <li>
            <p>
              THE ACCESS AND USE OF THE WEBSITES AND SERVICES IS ENTIRELY AT
              YOUR OWN RISK. THE WEBSITES AND SERVICES PROVIDE INFORMATION ON
              PRODUCTS, BRANDS AND RETAIL, AND THIS INFORMATION IS &ldquo;AS
              IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo;. CANAWHO AND THEIR
              AFFILIATES, OFFICERS, DIRECTORS, MANAGERS, SHAREHOLDERS, OWNERS,
              EMPLOYEES, CONTRACTORS, CONSULTANTS AND AGENTS EXPRESSLY DISCLAIM
              ALL WARRANTIES AND CONDITIONS OF ANY KIND, WHETHER EXPRESS OR
              IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES OR
              CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE
              AND NON-INFRINGEMENT, OR ANY OTHER POTENTIAL OR ACTUAL WARRANTY OF
              ANY KIND.
            </p>
          </li>
          <li>
            <p>
              CANAWHO AND ITS AFFILIATES (IE. OFFICERS, DIRECTORS, MANAGERS,
              SHAREHOLDERS, OWNERS, EMPLOYEES, CONTRACTORS, CONSULTANTS AND
              AGENTS) MAKE NO GUARANTEE OR WARRANTY THAT: (1) THE WEBSITES AND
              SERVICES WILL FULFIL YOUR NEEDS AND WILL BE COMPATIBLE WITH YOUR
              TECHNOLOGY; (2) THE WEBSITES AND SERVICES, AND ALL AFFILIATED
              WEBSITES, FEATURES, SERVICES, COMMUNICATIONS AND APPLICATIONS,
              WILL BE COMPREHENSIVE, UNINTERRUPTED, TIMELY, SECURE OR
              ERROR-FREE, OR BE FREE FROM LOSS, DESTRUCTION, CORRUPTION, ONLINE
              ATTACK, VIRUSES, WORMS, OR OTHER INVASIVE, HARMFUL, OR CORRUPTED
              OR OTHER RELATED INTRUSIONS; (3) THE INFORMATION, DATA, ANALYTICAL
              UNDERSTANDING OBTAINED FROM YOUR USE OF THE WEBSITES OR SERVICES
              WILL BE ACCURATE, UP TO DATE, RELIABLE, FIT, OR USEFUL FOR ANY
              SPECIFIC PURPOSE; (4) THE QUALITY OR VALUE OF ANY PRODUCTS,
              SERVICES AND INFORMATION OBTAINED OR PURCHASED BY YOU THROUGH THE
              WEBSITES AND SERVICES WILL MEET YOUR EXPECTATIONS; (5) THAT ANY
              MESSAGE SENT OR EXPERIENCE SHARED WILL BE SUCCESSFULLY
              TRANSMITTED, RECEIVED AND PROCESSED; AND (6) ANY ERRORS MADE IN
              THE GUIDELINES, TERMS OF USE, PRIVACY POLICY, SOFTWARE OR
              PROTOCOLS WILL BE CORRECTED OR RESOLVED.
            </p>
          </li>
          <li>
            <p>
              ANY PRODUCT, MATERIAL, APPLICATION, FEATURE OR PROGRAM OBTAINED OR
              DOWNLOADED THROUGHOUT THE USE OF THE WEBSITES AND SERVICES IS TO
              BE USED AT YOUR OWN RISK, AND YOU WILL BE ENTIRELY RESPONSIBLE AND
              COMPLETELY LIABLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR MOBILE
              DEVICE, LOSS OF DATA, OR ANY OTHER LOSS OR DAMAGE AS A RESULT OF
              DOWNLOADING OR USING ANY PRODUCT, MATERIAL, APPLICATION, FEATURE
              OR PROGRAM.
            </p>
          </li>
          <li>
            <p>
              NO ADVICE OR INFORMATION, INCLUDING MEDICAL ADVICE, TIPS AND
              TRICKS, BEST PRACTICES, GUIDELINES OR RELATED CONTENT, WHETHER IT
              BE ORAL, WRITTEN OR VIDEO THAT WAS OBTAINED THROUGH CANAWHO OR
              FROM THE WEBSITES OR SERVICES OR RELEVANT SOCIAL MEDIA PAGES SHALL
              CREATE ANY CONDITION, PROMISE OR GUARANTEE&nbsp; NOT EXPRESSLY
              STATED IN THESE TERMS.
            </p>
          </li>
          <li>
            <p>
              CANAWHO&nbsp;MAY NOT BE ABLE TO REVIEW AND EXAMINE EACH AND EVERY
              COMMENT, IMAGE, VIDEO, EXPERIENCE, RELATED MEDIA, SHARED
              EXPERIENCE OR ANY OTHER FORM OF COMMUNICATION AND ANY OTHER
              CONTENT POSTED VIA THE WEBSITES OR SERVICES. AS A RESULT, CANAWHO
              CANNOT AND DOES NOT CONTROL ANY EXPERIENCES RELATED TO ANY
              LISTING, COMMENTS, IMAGES, OPINIONS, POSTINGS OR OTHER CONTENT OR
              MATERIAL POSTED VIA THE WEBSITES OR SERVICES. CANAWHO DOES NOT
              GUARANTEE AND IS NOT RESPONSIBLE FOR THE ACCURACY, QUALITY,
              SAFETY, INTEGRITY, LEGALITY, MORALITY, AND/OR AUTHENTICITY OF SUCH
              CONTENT, THE ABILITY OF LISTINGS TO CONFIRM PRODUCT AVAILABILITY
              OR PRICING, THE TRUTH OR ACCURACY OF USERS CONTENT, OR THE ABILITY
              OF USERS TO CONFIRM EXPERIENCES FROM USING OR PURCHASING SPECIFIC
              PRODUCTS DISCUSSED ON THE WEBSITES OR SERVICES.
            </p>
          </li>
          <li>
            <p>
              YOU ACKNOWLEDGE, UNDERSTAND AND AGREE THAT CANAWHO AND PARTIES
              (IE. OFFICERS, DIRECTORS, MANAGERS, SHAREHOLDERS, OWNERS,
              EMPLOYEES, CONTRACTORS, CONSULTANTS AND AGENTS) ARE NOT LIABLE,
              AND YOU AGREE NOT TO SEEK OR TO HOLD CANAWHO PARTIES LIABLE, FOR
              THE BEHAVIOR OF THIRD PARTIES, INCLUDING EXTERNAL SITES OPERATORS,
              AND THAT THE RISK OF INJURY FROM SUCH THIRD PARTIES IS ENTIRELY
              WITH YOU.
            </p>
          </li>
          <li>
            <p>
              YOU ARE ENTIRELY RESPONSIBLE FOR ALL OF YOUR COMMUNICATIONS,
              INTERACTIONS AND ENGAGEMENTS WITH OTHER COMMUNITY MEMBERS ON THE
              CANAWHO WEBSITES AND SERVICES. YOU UNDERSTAND THAT CANAWHO DOES
              NOT MAKE ANY ATTEMPT TO VERIFY THE STATEMENTS OF USERS ON THE
              CANAWHO WEBSITES AND SERVICES.
            </p>
            <p>&nbsp;</p>
            <h2>&nbsp;</h2>
          </li>
        </ol>
        <h1>12. Limitation of Liability</h1>
        <h2>You expressly acknowledge, understand and agree that:</h2>
        <p>&nbsp;</p>
        <ol start="13">
          <li>
            <p>
              CANAWHO IS NOT RESPONSIBLE FOR AND IS UNABLE TO GUARANTEE
              UNINTERRUPTED, CONSTANT OR SECURE ACCESS TO ITS WEBSITES,
              SERVICES, MOBILE APPLICATIONS, CONTENT AND NETWORK. THE
              PERFORMANCE OF THE WEBSITES AND SERVICES MAY BE INTERFERED WITH OR
              DELAYED BY NUMEROUS POTENTIAL FACTORS OUTSIDE THE CONTROL OF
              CANAWHO.&nbsp;
            </p>
          </li>
          <li>
            <p>
              YOU ACCEPT, CLEARLY UNDERSTAND AND AGREE THAT CANAWHO AND ITS
              SUBSIDIARIES, PARTNERS, LICENSORS, LICENSEES, AFFILIATES, AGENTS,
              OFFICERS AND EMPLOYEES, SHALL IN NO WAY BE LIABLE TO YOU FOR ANY
              INDIRECT, DIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE,
              EXEMPLARY OR OTHER DAMAGES, INCLUDING, BUT NOT LIMITED TO,
              PROFITS, REPUTATION, GOODWILL, VALUATION, DAMAGES FOR LOSS OF
              OPPORTUNITY, TAX BENEFIT OR DATA OR OTHER INTANGIBLE LOSSES (EVEN
              IF CANAWHO HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR
              LOSSES), INCLUDING DAMAGES OR LOSSES ARISING OUT OF: (1) USING THE
              WEBSITE, SERVICES AND/OR NETWORK OR HAVING THE INABILITY TO USE
              THE WEBSITE, SERVICES AND/OR NETWORK; (2) THE COST TO ACQUIRE
              GOODS AND SERVICES RESULTING FROM ANY GOODS, DATA, INFORMATION OR
              SERVICES PURCHASED OR OBTAINED, MESSAGES, E-MAILS, EXPERIENCES,
              SHARED EXPERIENCES, COMMENTS OR OTHER COMMUNICATIONS RECEIVED, OR
              TRANSACTIONS ENTERED INTO THE WEBSITES OR SERVICES OR OTHER
              AFFILIATED OR RELATED WEBSITES OR SERVICES; (3) UNAUTHORIZED
              ACCESS TO YOUR TRANSMISSIONS OR DATA; (4) ALTERATIONS OF YOUR
              TRANSMISSIONS OR DATA; (5) STATEMENTS, BEHAVIOUR, OR CONDUCT OF
              ANY THIRD PARTY ON THE WEBSITES; (6) THE NETWORK, WEBSITES OR
              SERVICES FAILURE TO TIMELY PROCESS AN OFFER OR TRANSACTION; (7)
              ANY DEFECTIVE OR INADEQUATE GOODS PURCHASED OR OBTAINED VIA THE
              WEBSITE OR SERVICES; OR (8) ANY OTHER MATTER RELATING TO THE
              WEBSITES OR SERVICES, ANY CANAWHO AFFILIATED OR RELATED SERVICES,
              FEATURES OR APPLICATIONS, OR ANY OTHER CANAWHO OWNED OR OPERATED
              ENTITY. FURTHER, CANAWHO IS NOT A PARTY TO ANY SUCH TRANSACTIONS
              MADE BETWEEN REGISTERED BUSINESSES AND COMMUNITY USERS, AND
              CANAWHO SHALL NOT BE LIABLE UNDER ANY CIRCUMSTANCES FOR ANY COSTS,
              DEFAULTS, INFORMATION, THE CONTENTS OF ANY DOCUMENTS, OR FOR ANY
              OTHER INTERACTIONS, BETWEEN OR AMONG USERS, INCLUDING USERS,
              COMPANY LISTINGS, PHYSICIANS, AND ALL RELATED PARTIES, IN ANY WAY
              ASSOCIATED WITH THE WEBSITES OR SERVICES.
            </p>
          </li>
          <li>
            <p>
              REGARDLESS OF THE AFOREMENTIONED AND REGARDLESS OF THE FORM OF
              ACTION (CONTRACT, TORT OR OTHERWISE), IF CANAWHO IS FOUND TO BE
              LIABLE, OUR AGGREGATE LIABILITY TO YOU OR TO ANY THIRD PARTY IS
              LIMITED TO THE GREATER OF (1) THE AMOUNT, IF ANY, OF FEES IN
              DISPUTE NOT TO EXCEED THE TOTAL FEES, WHICH YOU PAID TO US IN THE
              12 MONTHS PRIOR TO THE ACTION GIVING RISE TO THE LIABILITY; OR (2)
              CAD $100.
            </p>
          </li>
          <li>
            <p>
              SOME PROVINCES AND MUNICIPALITIES DO NOT ALLOW THE EXCLUSION OF
              CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR
              CONSEQUENTIAL, INCIDENTAL&nbsp; OR OTHER DAMAGES OR LOSSES.
              ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS OR EXCLUSIONS MAY NOT
              APPLY TO YOU.
            </p>
          </li>
        </ol>
        <p>&nbsp;</p>
        <h1>
          <strong>13. Term and Termination.</strong>
        </h1>
        <h2>
          <strong>13.1 Term.</strong>
        </h2>
        <p>
          The Terms are effective and begin on the date when you accept them (as
          described in the preamble above) and remain completely active and in
          full effect while you use the Website and Services. The Terms will
          remain in effect unless the terms are terminated earlier in accordance
          with the Terms.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>13.2 Prior Use.</strong>
        </h2>
        <p>
          Notwithstanding the foregoing, if you used the Website and Services
          before you accepted the Terms, you hereby accept and agree that the
          Terms began and took effect on the date you first accessed and used
          the Website and Services (whichever is earlier) and will continue to
          remain in full effect while you use the Website and Services. The
          Terms will remain in effect unless the terms are terminated earlier.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>13.3 Additional Termination Rights.</strong>
        </h2>
        <p>
          This Agreement may be terminated or its performance may be suspended
          at any time by either party upon notice to the other party if the
          other party breaches any term of this document. If the other party
          fails to relieve such violation in accordance with the following
          relief procedure, and if another party violates this Agreement and the
          non-violating party wishes to terminate this Agreement, then the
          non-violating party shall serve a written notice to the violating
          party describing the violation and requiring it to be resolved. If the
          violation has not been resolved within the first thirty (30) days of
          the original notice or such period as may be agreed upon, then the
          notifying party will have the right to terminate this Agreement with
          another written notice that will be effective immediately. CanaWho may
          also decommission and terminate the Websites and Services at any time
          with a thirty (30) days&rsquo; notice.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>13.4 Effect of Termination.</strong>
        </h2>
        <p>
          The termination of any Service includes removing access to such
          Service and barring of further use of the Service. If the Services are
          terminated, the following information will be terminated including all
          information, passwords, Content and files associated with or inside
          your Account. With the termination of any Service, your right to use
          such Service will automatically end immediately. You understand and
          accept that if any Services are terminated, then this may result in
          the deletion of Your Content associated with your Account from our
          live databases. CanaWho will not have any liability or be responsible
          whatsoever to you for any suspension or termination, including the
          deletion of Your Content. All provisions of the Terms which by their
          nature should survive, shall survive termination of Services,
          including without limitation, ownership provisions, warranty
          disclaimers, and limitations and exclusions of liability.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>13.5 No Subsequent Registration.</strong>
        </h2>
        <p>
          If you are restricted by CanaWho to register or access the Websites
          and Services because you have violated any portion of the Terms or
          have been found to be inappropriate within CanaWho&rsquo;s community,
          then you agree and accept that you shall not try to re-register with
          or access the CanaWho community through a different username, and you
          accept and agree that you will not be entitled to receive a refund for
          any fees related to the Websites or Services because your access has
          already been terminated.
        </p>
        <p>
          If you violate the immediately preceding sentence, CanaWho reserves
          the right, in its sole discretion, to immediately take any or all of
          the actions set forth herein without any notice or warning to you.
        </p>
        <h1>
          <br />
          14. International Users.
        </h1>
        <p>
          The Website and Services may be accessible from countries other than
          Canada and may contain Information, Services and Content that are not
          available in your country. These references do not imply that CanaWho
          intends to announce the Services or Content in your country. CanaWho
          controls and offers the Website and Services from Canada. CanaWho
          makes no representations that the Website and Services are appropriate
          or available for use in other locations. If you access or use the
          Website and Services from a country outside of Canada, then you are
          doing so at your own volition and you are responsible for complying
          with local law.
        </p>
        <p>
          <br />
          <br />
        </p>
        <p>
          <strong>
            Dispute Resolution. Please read the following Arbitration Agreement
            in the Section below (&ldquo;Arbitration Agreement&rdquo;)
            carefully. It notifies and requires you to arbitrate disputes with
            CanaWho&trade; and limits the manner in which you can seek relief
            from us.
          </strong>
        </p>
        <h1>
          <br />
          15. Arbitration.
        </h1>
        <h2>&nbsp;</h2>
        <h2>
          <strong>15.1 Arbitration Agreement Applicability.</strong>
        </h2>
        <p>
          You agree that any dispute or claim relating in any way to your access
          or use of the Website or Services, to any products viewed or content
          displayed, or to any part of your relationship with CanaWho, will be
          resolved through binding arbitration, rather than in court, except
          that (1) you may submit claims in court if your claims qualify, so
          long as the matter remains in small claims court and only advances on
          an individual (non-class, non-representative) basis; and (2) you or
          CanaWho may seek fair relief in court for violations or other misuse
          of intellectual property rights (such as domain names, trade dress,
          trade secrets, trademarks, copyrights, and patents).
          <strong>
            &nbsp;This Arbitration Agreement shall apply to all claims without
            limitation that arose or were asserted before the effective date of
            these Terms or any prior version of this Agreement.
          </strong>
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>
            YOU AGREE AND ARE AGREEING IN ADVANCE THAT YOU WILL NOT PARTICIPATE
            IN OR SEEK TO RECOVER MONETARY OR OTHER RELIEF IN ANY LAWSUIT FILED
            AGAINST CanaWho ALLEGING CLASS, COLLECTIVE, AND/OR REPRESENTATIVE
            CLAIMS ON YOUR BEHALF. YOU MAY BRING YOUR CLAIMS AGAINST CanaWho Inc
            IN AN INDIVIDUAL ARBITRATION PROCEEDING. IF SUCCESSFUL ON SUCH
            CLAIMS, YOU COULD BE AWARDED MONEY OR OTHER RELIEF BY AN ARBITRATOR.
            YOU ACKNOWLEDGE THAT YOU HAVE BEEN ADVISED THAT YOU MAY CONSULT WITH
            AN ATTORNEY IN DECIDING WHETHER TO ACCEPT THESE TERMS, INCLUDING
            THIS ARBITRATION AGREEMENT.
          </strong>
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>15.2 Arbitration Rules.</strong>
        </h2>
        <p>
          The Federal Arbitration Act governs the interpretation and enforcement
          of this Arbitration Agreement. To begin an arbitration proceeding, you
          must send a letter requesting arbitration and describing your claim to
          CanaWho Inc, 2238 Dundas Street W, PO BOX 59047, Toronto, Ontario M6R
          3B5. The parties will select an arbitrator to mediate the arbitration.
          If the arbitrator finds that you cannot afford to pay the filings,
          administrative, hearing and/or other fees and cannot obtain a waiver
          from the arbitrator, CanaWho will pay them for you. In addition,
          CanaWho will reimburse all such arbitrator filing, administrative,
          hearing and/or other fees for claims totaling less than $10,000 CAD
          unless the arbitrator determines the claims are frivolous. Likewise,
          CanaWho will not seek attorney(s) fees and costs in arbitration unless
          the arbitrator determines the claims are frivolous. You may choose to
          have the arbitration via telephone, based on written submissions, or
          in person in the country where you live or at another mutually agreed
          location. Any judgment on the award rendered by the arbitrator may be
          entered in any court of competent jurisdiction.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>15.3 Authority of the Arbitrator.</strong>
        </h2>
        <p>
          The Arbitrator, and not any Federal, Provincial, or Municipal court or
          agency shall have exclusive authority to (a) determine the scope and
          enforceability of this Arbitration Agreement and (b) resolve any
          dispute related to the applicability, interpretation, enforceability
          or formation of this Arbitration Agreement including, but not limited
          to any claim that all or any part of this Arbitration Agreement is
          void or voidable. The arbitration will decide the rights and
          liabilities if there are any between you and CanaWho. The arbitration
          process will not be combined with any other matters or grouped with
          any other cases or parties. The arbitrator has the authority to grant
          motions and settle all or part of any claim brought forth. The
          arbitrator shall have the authority to award monetary damages and to
          grant any non-monetary remedy or relief available to an individual
          under applicable law, the arbitral forum&rsquo;s rules, and the Terms
          (including the Arbitration Agreement). The arbitrator shall provide a
          written award and statement of decision which describes the findings
          and conclusions on which the award is based, including the calculation
          of any damages awarded. The arbitrator in this event has the same
          authority as a judge in a court of law to award relief on an
          individual basis as a result of the arbitration process. The award
          determined and granted by the arbitrator is final and is binding upon
          you and CanaWho.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>15.4 Waiver of Jury Trial.</strong>
        </h2>
        <p>
          YOU AND CanaWho HEREBY WAIVE ANY CONSTITUTIONAL AND STATUTORY RIGHTS
          TO SUE IN COURT AND HAVE A TRIAL IN FRONT OF A JUDGE OR A JURY. You
          and CanaWho are instead selecting that all claims and disputes shall
          be resolved by an arbitrator under this Arbitration Agreement, except
          as specified in Section 15.1 above. An arbitrator can award on an
          individual basis the same relief and damages as a court and must
          follow this Agreement as a court would. However, there is no judge or
          jury in arbitration, and court review of an arbitration award is
          subject to very limited review.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>15.5 Waiver of Class or Consolidated Actions.</strong>
        </h2>
        <p>
          ALL OF THE CLAIMS AND DISPUTES THAT FALL WITHIN THE SCOPE OF THIS
          ARBITRATION AGREEMENT MUST BE ARBITRATED ON AN INDIVIDUAL BASIS SOLELY
          AND CANNOT BE ARBITRATED ON A CLASS BASIS, RELIEF IS ONLY AVAILABLE ON
          AN INDIVIDUAL BASIS. CLAIMS MADE BY MORE THAN ONE PERSON OR USER
          CANNOT BE ARBITRATED OR CONSOLIDATED WITH THOSE OF ANY OTHER PERSON OR
          USER. If this paragraph is found to be invalid or unenforceable, you
          or CanaWho are not able to arbitrate and instead claims and disputes
          shall be resolved in the Federal or Provincial Courts.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>15.6 Right to Opt Out, 30-Days.</strong>
        </h2>
        <p>
          You the person or user have the right to opt out of the provisions of
          this Arbitration Agreement by sending your decision in a written
          notice or by sending an email to opt out. You may send your written
          notice to the following address: CanaWho Inc, 2238 Dundas Street W, PO
          BOX 59047, Toronto, Ontario, M6R 3B5 and you may send your email
          to&nbsp;
          <a href="mailto:customerservice@canawho.com">
            customerservice@canawho.com
          </a>
          &nbsp;within 30 days after first becoming subject to this Arbitration
          Agreement. Your written notice must include the following: name,
          address, CanaWho username , the email address you used to set up your
          Account with CanaWho (if you have one), and a clear statement that you
          want to opt out of this Arbitration Agreement. If you do choose to opt
          out of this Arbitration Agreement, all of the other parts of these
          Terms will continue to apply directly to you. By opting out of this
          Arbitration Agreement, this has no effect on any other Arbitration
          Agreements that you may currently have, or may enter in the future,
          with CanaWho.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>15.7 Severability.</strong>
        </h2>
        <p>
          If any part or parts of this Arbitration Agreement is or are found to
          be invalid under the law or unenforceable, then the specific part or
          parts shall have no effect and the remainder of the Arbitration
          Agreement shall continue to be in full effect.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>15.8 Survival of Agreement.</strong>
        </h2>
        <p>
          This Arbitration Agreement will continue beyond the termination of
          your relationship with CanaWho and the termination of these Terms.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>15.9 Modification.</strong>
        </h2>
        <p>
          Notwithstanding any provision in this Agreement to the contrary, we
          agree that if CanaWho makes any changes to this Arbitration Agreement
          in the future, it will not apply to any individual claim(s) already
          under review that you had already provided notice to CanaWho.
        </p>
        <h2>
          <br />
          16. General Provisions.
        </h2>
        <h2>&nbsp;</h2>
        <h2>
          <strong>16.1 Communications Electronically.</strong>
        </h2>
        <p>
          When you access or use the Websites or Services, you agree and give
          consent to receive certain electronic communications from CanaWho. We
          will communicate with you in the following ways, without limitation,
          through in-app notices, text, email or through the Websites or
          Services. By accessing or using the Websites or Services, you
          voluntarily and knowingly agree that all notices, agreements,
          contracts, disclosures and other communications provided to you
          electronically satisfy any legal requirement that such communications
          be in writing.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>16.2 Privacy Statement.</strong>
        </h2>
        <p>
          When you access or use CanWho&rsquo;s Websites or Services, you agree
          that CanaWho&rsquo;s collection and use of your personal information
          is governed by the CanaWho Privacy Policy (which may be updated
          periodically). If you would like more information, please feel free to
          review our Privacy Policy. You understand that when you access or use
          the Websites or any of the Services, you consent to the collection and
          use (as set forth in the Privacy Policy) of this information.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>16.3 Choice of Law; Venue; No Jury Trial</strong>
        </h2>
        <p>
          The laws within the province of Ontario and Canada, will apply to any
          disputes arising out of or relating to these Terms or any of the
          Websites or Services. All claims arising out of or relating to these
          Terms or any of the Websites or Services will be litigated exclusively
          in the provincial or Federal Courts of Canada, and you and CanaWho
          consent to personal jurisdiction in those courts.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>16.4 Entire Agreement.</strong>
        </h2>
        <p>
          These Terms, any applicable Additional Terms, Privacy Policy and any
          other agreements between you and CanaWho relative to the Websites or
          Services, make up the entire and exclusive understanding and agreement
          between CanaWho and you regarding the Websites and Services, and these
          Terms replace any and all prior Terms of Service for any of the
          Websites or Services.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>16.5 Reservation Of Rights.</strong>
        </h2>
        <p>
          The failure of CanaWho to enforce any right or provision of these
          Terms will not constitute a waiver of future enforcement of that right
          or provision. The waiver of the right or provision will only be
          effective if it is in writing and it is signed by an appropriate
          authorized representative of CanaWho. Except as expressly set forth in
          these Terms, the exercise by either party of any of its remedies under
          these Terms will be without prejudice to its other remedies under
          these Terms or otherwise. If for any reason a court of competent
          jurisdiction finds any provision of these Terms invalid or
          unenforceable, that condition or requirement will be enforced to the
          maximum extent allowed and the other provisions of these Terms will
          remain in full force and effect.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>16.6 Third Party Beneficiary.</strong>
        </h2>
        <p>
          The Terms of Service found in this document do not and are not
          intended to grant any rights upon any person other than yourself and
          CanaWho except as otherwise clearly stated in these Terms.
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>16.7 Support or Maintenance.</strong>
        </h2>
        <p>
          You accept, agree and understand that CanaWho is not obligated to
          provide you with any support or maintenance in relation to the
          Websites or Services.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>16.8 Release.</strong>
        </h2>
        <p>
          You hereby release and forever discharge CanaWho (and its owners,
          partners, directors, officers, managers, employees, independent
          contractors, successors and assigns of itself or its affiliates) from,
          and hereby waive and relinquish your rights with respect to, each and
          every past, present and future dispute, demand, claim, controversy,
          liability, obligation, right, action and cause of action of every kind
          and nature (including property damage, personal injuries and death),
          that has arisen or will arise directly or indirectly out of, or
          relates directly or indirectly to, any interactions with, or act or
          omission of, other websites or services or Third Party
          Materials.&nbsp;
        </p>
        <p>&nbsp;</p>
        <h2>
          <strong>16.9 Servability.</strong>
        </h2>
        <p>
          If any conditions within the Terms of Service are found to be deemed
          invalid, null, or for any reason unenforceable, then that condition
          shall be removed and will not affect the validity and enforceability
          of the remaining conditions found within the Terms of Service.
        </p>
        <h2>&nbsp;</h2>
        <h2>
          <strong>16.10 Contact Us.</strong>
        </h2>
        <p>
          If you have any questions about the Websites and Services provided by
          Canawho Inc, then feel free to contact us at&nbsp;
          <a href="mailto:customerservice@canawho.com">
            customerservice@canawho.com
          </a>
          &nbsp;and we would love to help you.
        </p>
      </div>
    );
  }
}
